import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Accordion, AccordionDetails, AccordionSummary, Typography, Tooltip } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SimpleTableViewer from '../SimpleTable';
import Button from '@material-ui/core/Button';
import CardInfoViewer from '../CardInfo';

const useStyles = makeStyles((theme) => ({
    /* ===========================
       ACCORDION
    =========================== */
    accordionRoot: {
        '&::before': { display: 'none' },
        borderRadius: '4px 4px 0 0',
        border: '1px solid #EEE',
        // backgroundColor: '#FAFAFA',
        boxShadow: 'none',
        '&.Mui-expanded': { margin: 0 },
    },

    accordionDetails: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '70vh', // Set a maximum height
        overflowY: 'auto', // Enable vertical scrolling
        // padding: '16px 24px',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        // scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
    },

    expandedSummary: {
        /* xl baseline */
        '&.MuiAccordionSummary-root': { maxHeight: 60, minHeight: 60 },
        '&.Mui-expanded': { maxHeight: 60, minHeight: 60 },
        '& .MuiAccordionSummary-expandIcon': { marginRight: '5px !important' },
        '& .MuiAccordionSummary-expandIcon.Mui-expanded': { marginRight: '5px !important' },
        '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
    },
}));

const SimpleAccordionViewer = (props) => {
    const classes = useStyles();
    const { blockState, tableData, infoCardData, accordionHeader, AccordionDetailsHeader, formData, handleRemove, selectedDataElement, subDataElement, obligationManagementData, selectedDataElement1, selectedDataElement2, subDataElement1, linkedContractsdataElements, contract } = props;

    const headerValue = (item, value) => {
        if (item[value]) {
            return typeof item?.[value] === 'object' ? item?.[value]?.value : item?.[value];
        }
        return '-';
    }

    const isButtonEnabled = props.enableWorkflow && props.blockState?.['status'] !== 'Rejected' && props.blockState?.['status'] !== 'Completed' && props.blockState?.workflow && props.blockState?.workflow?.currentRespondent?.id === props.members?._id;
    console.log('SimpleAccordionViewer**isButtonEnabled', isButtonEnabled, props.blockState, props.members, props.enableWorkflow, props.blockState, props.members?._id)
    const handleExport = (id, item) => {
        let payload = {
            dataModelId: "667db229f66e61243a4cc672",
            appid: props.match.params.appid,
            fields: contract?.obligationManagement?.selectedDataElement.map(i => i.value).join(",") + "," + contract?.clause?.selectedDataElement.map(i => i.value).join(",") + "," + linkedContractsdataElements.map(i => i.value).join(","),
            ids: [id],
            downloadType: 'excel',
            dataUniqueId: props.data.chartUniqueId + '_' + id + '_download',
        }
        props.downloadSheet(payload);
    }

    const createDocumentHierarchyArray = (hierarchyData, currentDocumentId) => {
        const result = [];

        // Find the current document and its relationships
        const findDocumentAndRelations = (node, parentNode = null) => {
            if (node?._id === currentDocumentId) {
                // Add parent first (if exists)
                if (parentNode) {
                    result.push({
                        ...parentNode,
                        relation: "Parent"
                    });
                }

                // Add siblings (other children of the same parent)
                if (parentNode && parentNode?.children) {
                    const siblings = parentNode.children.filter(child => child._id !== currentDocumentId);
                    siblings.forEach(sibling => {
                        result.push({
                            ...sibling,
                            relation: "Sibling"
                        });
                    });
                }

                // Add current document
                result.push({
                    ...node,
                    relation: "Current"
                });

                // Add children
                if (node?.children && node?.children?.length > 0) {
                    node.children.forEach(child => {
                        result.push({
                            ...child,
                            relation: "Child"
                        });
                    });
                }
            }

            // Recursively search in children
            if (node?.children && node?.children?.length > 0) {
                node.children.forEach(child => {
                    findDocumentAndRelations(child, node);
                });
            }
        };

        findDocumentAndRelations(hierarchyData);
        return result;
    };

    const handleOpenView = (item) => {
        props.history.push({
            pathname: `/${props?.match?.params?.appid}/page/view/${item?.id}`
        });
    }

    return (
        <React.Fragment>
            {
                tableData?.length > 0 && tableData?.map((item, index) => {
                    const documentHierarchyArray = createDocumentHierarchyArray(item?.[contract?.contractHierarchies?.name] ? item?.[contract?.contractHierarchies?.name] : {}, item?.id);
                    return (
                        <Accordion
                            elevation={0}
                            className={classes.accordionRoot}
                            defaultExpanded={contract?.accordionSupport?.defaultExpanded}
                        >
                            <AccordionSummary
                                className={classes.expandedSummary}
                                expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
                            >
                                <div style={{ height: '40px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                                    <div style={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxSizing: 'border-box' }}>
                                        <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#5F6071', fontStyle: 'normal', lineHeight: '24px' }}>{`${contract?.accordionSupport?.accordionHeader?.label} :`}</Typography>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: '8px', boxSizing: 'border-box' }}>
                                            <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#2B2C35', fontStyle: 'normal', lineHeight: '24px' }}>{headerValue(item, contract?.accordionSupport?.accordionHeader?.value)}</Typography>
                                            {
                                                contract?.actions?.view?.enable && <img src={'/media/createStepper/openView.svg'} alt="download" style={{ width: '16px', height: '16px' }} onClick={() => { handleOpenView(item) }} />
                                            }
                                        </div>

                                    </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails className={`${classes.accordionDetails} myScrollContainer`}>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                    <div style={{ height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxSizing: 'border-box' }}>
                                        <div style={{ height: '40px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <div style={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxSizing: 'border-box' }}>
                                                <div style={{ height: '20px', width: '2px', backgroundColor: '#3F51B5' }}>

                                                </div>
                                                <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#5F6071', fontStyle: 'normal', lineHeight: '24px' }}>{`${contract?.accordionSupport?.AccordionDetailsHeader?.label} :`}</Typography>
                                                <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#2B2C35', fontStyle: 'normal', lineHeight: '24px' }}>{headerValue(item, contract?.accordionSupport?.AccordionDetailsHeader?.value)}</Typography>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: '12px', boxSizing: 'border-box' }}>
                                            <div style={{ height: '35px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                                                <Button
                                                    style={{ backgroundColor: '#3F51B5', color: '#fff', border: '1px solid #3F51B5', borderRadius: '4px', height: '35px', padding: '12px', boxSizing: 'border-box' }}
                                                    onClick={() => { handleExport(item.id, item) }}
                                                >
                                                    {contract?.actions?.export?.label}
                                                </Button>
                                            </div>
                                            <div style={{ height: '35px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                                                <Button
                                                    style={{ 
                                                        color: isButtonEnabled ? '#3F51B5' : '#BDBDBD', 
                                                        border: `1px solid ${isButtonEnabled ? '#3F51B5' : '#E0E0E0'}`, 
                                                        borderRadius: '4px', 
                                                        height: '35px', 
                                                        padding: '12px', 
                                                        boxSizing: 'border-box',
                                                        backgroundColor: !isButtonEnabled ? '#F5F5F5' : 'transparent',
                                                        cursor: !isButtonEnabled ? 'not-allowed' : 'pointer',
                                                        opacity: !isButtonEnabled ? 0.6 : 1
                                                    }}
                                                    disabled={!isButtonEnabled}
                                                    onClick={() => { handleRemove(item.id, item) }}
                                                >
                                                    {contract?.actions?.remove?.label}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                    <CardInfoViewer {...props} data={contract?.cardInformation?.selectedDataElement} blockState={item?.["cardInformation"] ? item?.["cardInformation"] : {}} />

                                    <SimpleTableViewer {...props} title={contract?.obligationManagement?.title} dataObj={item?.[contract?.obligationManagement?.name] ? item?.[contract?.obligationManagement?.name] : {}} selectedDataElement={contract?.obligationManagement?.selectedDataElement} dataModel="66e8297ca40acb5c5c38248a" selectedTableDataElement={contract?.obligationManagement?.subDataElement} isActionEnabled={contract?.obligationManagement?.actions?.enable} isObjectTable={contract?.obligationManagement?.actions?.isObjectTable} />

                                    <SimpleTableViewer {...props} title={contract?.clause?.title} dataObj={item?.[contract?.clause?.name] ? item?.[contract?.clause?.name] : {}} selectedDataElement={contract?.clause?.selectedDataElement} dataModel="66e8297ca40acb5c5c38248a" selectedTableDataElement={contract?.clause?.subDataElement} isActionEnabled={contract?.clause?.actions?.enable} isObjectTable={contract?.clause?.actions?.isObjectTable} />

                                    <SimpleTableViewer {...props} title={contract?.contractHierarchies?.title} dataObj={documentHierarchyArray} selectedTableDataElement={contract?.contractHierarchies?.selectedDataElement} isActionEnabled={contract?.contractHierarchies?.actions?.enable} isObjectTable={contract?.contractHierarchies?.actions?.isObjectTable} />
                                </div>

                            </AccordionDetails>
                        </Accordion>
                    )
                })
            }
            {
                tableData?.length === 0 && (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#5F6071', fontStyle: 'normal', lineHeight: '18px' }}>{contract?.noContracts}</Typography>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default SimpleAccordionViewer